/**
 * Design tokens shared by the React primitives and the MUI theme bridge.
 *
 * Mirrors `src/ui/tokens.css`; keep the two in step. Source: Pinnacle Brand
 * Standards 11-26-22 (Pantone 425 C is the only brand colour) and the Employee
 * Hub reference UI.
 */

export const palette = {
  tpc50: "#f7f7f7",
  tpc100: "#efefef",
  tpc200: "#dcdcdc",
  tpc300: "#c0c0c0",
  tpc400: "#969696",
  tpc500: "#737373",
  tpc600: "#555759",
  tpc700: "#3e4042",
  tpc800: "#2a2b2d",
  tpc900: "#131517",
  tpc950: "#0a0b0c",
  white: "#ffffff",
  black: "#000000",
} as const;

// Concrete values: MUI computes alpha() over palette colours and cannot read
// CSS custom properties there. Component CSS uses the variables instead.
export const status = {
  green: {
    dot: "#059669",
    text: "#065f46",
    bg: "#ecfdf5",
  },
  amber: {
    dot: "#f59e0b",
    text: "#92400e",
    bg: "#fffbeb",
  },
  red: {
    dot: "#dc2626",
    text: "#991b1b",
    bg: "#fef2f2",
  },
  neutral: {
    dot: "#969696",
    text: "#3e4042",
    bg: "#efefef",
  },
} as const;

export const fontFamily =
  '"Brandon Grotesque", "Trebuchet MS", system-ui, sans-serif';

export const tracking = {
  head: "0.15em",
  eyebrow: "0.25em",
  button: "0.2em",
  table: "0.05em",
} as const;

export type StatusTone = keyof typeof status;
export type Tone = "info" | "warn" | "error" | "success";
export type TagTone = "neutral" | "brand" | "outline" | StatusTone;
